import teamsnapSdk from 'utils/teamsnapSdk';
import { addItems } from 'state/teamsnap/actions';

export const loadSports = () => (dispatch, getState) => {
  dispatch(addItems({ items: teamsnapSdk().sports }));
};
